import { forwardRef } from "react";

const padTop = 20;
const padBottom = 8;
const padLeft = 8;
const padRight = 8;

const BoundingBox = forwardRef(
  ({ coordinates, dimensions, zoom, className, rotate }, ref) => {
    if (!dimensions || !coordinates) return null;
    const { top, left, bottom, right } = coordinates;
    if (!top || !left || !bottom || !right) return null;
    return (
      <div
        ref={ref}
        className={`${className} bounding-box`}
        style={{
          top: `${((top - padTop) / dimensions.height) * 100}%`,
          left: `${((left - padLeft) / dimensions.width) * 100 * zoom}%`,
          width: `${
            ((right - left + padLeft + padRight) / dimensions.width) *
            100 *
            zoom
          }%`,
          height: `${
            ((bottom - top + padTop + padBottom) / dimensions.height) * 100
          }%`,
        }}
      />
    );
  }
);

BoundingBox.defaultProps = {
  coordinates: {},
  className: "",
};

export default BoundingBox;
